import "./fallbackComponent.scss";
import HomeLine from "../../../components/assets/HomeLine";
import RefreshCCW from "../../../components/assets/RefreshCCW";
import Button from "../../../components/common/Buttons/Button";
import Typography from "../../../components/common/Typography";

const errMsgListForNewUpdate = [
  "Unable to preload", // for css in chrome
  "Loading failed for the stylesheet", // for css in firefox
  "dynamically imported module", // for chromium based, firefox
  "Failed to load module script", // for old edge and safari
  "The server responded with a non-JavaScript MIME type", // for safari
  "could not be loaded because the server responded with an error: (404).", // for css in safari
];

const FallbackComponent = ({ error }) => {
  const isNewUpdateAvailable =
    error instanceof TypeError &&
    errMsgListForNewUpdate.some((errMsg) => error?.message?.includes(errMsg));

  return (
    <div className="root-fallback-component">
      <Typography size="display-lg" weight="medium" customClass="title">
        {isNewUpdateAvailable
          ? "New update available!"
          : "An error occurred on this page"}
      </Typography>
      {isNewUpdateAvailable || error?.message?.length > 0 ? (
        <Typography customClass="subtitle">
          {isNewUpdateAvailable ? (
            "Please reload the page to get the latest update."
          ) : (
            <>
              It seems something went wrong while loading the page. Please try
              reloading it to continue. If the issue persists, consider reaching
              out to Reelo support for further assistance, or feel free to try
              again later. Thank you for your patience!
              <br />
              <br />
              Error Message: {error?.message}
              <br />
              Page: {window.location.pathname}
            </>
          )}
        </Typography>
      ) : (
        <></>
      )}
      <div className="action-btns">
        {!isNewUpdateAvailable && (
          <Button
            size="lg"
            fullWidth
            variant="secondary"
            text="Redirect to Dashboard"
            leftIcon={<HomeLine width={18} height={18} />}
            handleClick={() => {
              window.location.href = "/";
            }}
          />
        )}
        <Button
          size="lg"
          fullWidth
          text="Reload page"
          rightIcon={<RefreshCCW width={18} height={18} color="#fff" />}
          handleClick={() => {
            window.location.reload();
          }}
        />
      </div>
    </div>
  );
};

export default FallbackComponent;
